<template>
  <v-card class="pa-2 my-2" dark>
    <v-card-title>Grant Types</v-card-title>
    <v-card-text>
      <v-flex>
        <v-data-iterator
          hide-default-footer
          :disable-pagination="true"
          :items="grantTypes">
          <template v-slot:default="props">
            <v-layout
              v-for="(item, index) in props.items"
              :key="index"
              wrap>
              <v-flex xs8>
                <v-text-field
                  :value="item.grantType"
                  :label="'Grant Type'"
                  @input="updateGrantType(index, $event)">
                </v-text-field>
              </v-flex>
              <v-flex class="align-self-center" xs4>
                <v-spacer></v-spacer>
                <v-icon @click="save(index)">
                  mdi-content-save
                </v-icon>
              </v-flex>
            </v-layout>
          </template>
        </v-data-iterator>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ['grantTypes'],
  methods: {
    updateGrantType (i, e) {
       this.$eventHub.$emit('updateGrantType', {i, e})
    },
    save (i) {
       this.$eventHub.$emit('saveGrantType', i)
    }
  }
}
</script>